import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { SponsorBanner } from '@synergy/models';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';

export const SPONSOR_BANNER_LIST_FETCH = 'SPONSOR_BANNER_LIST_FETCH';
export const SPONSOR_BANNER_LIST_RECEIVE = 'SPONSOR_BANNER_LIST_RECEIVE';
export const SPONSOR_BANNER_LIST_ERROR = 'SPONSOR_BANNER_LIST_ERROR';

export const receiveSponsorBannerList = (sponsorBanner: PaginatedResponse<SponsorBanner>) => {
    return {
        type: SPONSOR_BANNER_LIST_RECEIVE,
        sponsorBanner,
    };
};

const sponsorBannerListError = () => {
    return {
        type: SPONSOR_BANNER_LIST_ERROR,
    };
};

export const fetchSponsorBannerList = (searchParams: URLSearchParams = new URLSearchParams()) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: SPONSOR_BANNER_LIST_FETCH });
        const response = await api.contentManagement.SponsorBanner.SponsorBannerList.getSponsorBanners(searchParams);
        if (response.success) {
            dispatch(receiveSponsorBannerList(response.result));
        } else {
            dispatch(sponsorBannerListError());
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
